import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getTicketasignar } from '../../../redux/actions';
import CardContainer from "../Asignartecnico/CardsContainer";
import PacmanLoader from 'react-spinners/PacmanLoader';
import { FaUserPlus } from 'react-icons/fa';
import styles from "./Card.module.css";
// Reuse global pro styles if available, or define local ones in a common place
import globalStyles from '../../../view/Tickets/GenerarTicket.module.css';

const Asignartecnico = () => {
    const dispatch = useDispatch();
    const asignartec = useSelector((state) => state.ticketasignar);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTickets = async () => {
            await dispatch(getTicketasignar());
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        };

        loadTickets();
    }, [dispatch]);

    return (
        <div className={globalStyles.container}>
            <header className={globalStyles.header}>
                <h2 className={globalStyles.title}>
                    <FaUserPlus style={{ marginRight: '15px' }} />
                    Asignar Técnico
                </h2>
                <p className={globalStyles.subtitle}>
                    Gestiona la asignación de personal técnico para los requerimientos pendientes de TI.
                </p>
            </header>

            {loading ? (
                <div className={styles.pageSpinner}>
                    <PacmanLoader color="#3b82f6" loading={loading} size={40} />
                    <p style={{ marginTop: '20px', color: '#64748b', fontWeight: '600' }}>Cargando solicitudes...</p>
                </div>
            ) : (
                <CardContainer asignartec={asignartec} />
            )}
        </div>
    );
};

export default Asignartecnico;
